import { Message } from 'semantic-ui-react';
import { Component } from "react";
import Step2DetailApproval from './Step2DetailApproval';
import Step2DetailRejection from './Step2DetailRejection';
import Step2DetailIneligible from './Step2DetailIneligible';



class Step2NotificationLetter extends Component {

    getEligibilityDecision = () => {
        const projectState = this.props.projectState;
        const project = projectState.project;
        if (project.secondStepDecision !== null) {
            if (project.secondStepDecision.preFundingDecision !== null || project.secondStepDecision.finalFundingDecision !== null) {            
                if (project.secondStepDecision?.preFundingDecision?.status === 'APPROVED_WITH_CONDITIONS' || project.secondStepDecision?.finalFundingDecision?.status === 'APPROVED') {
                    return <Step2DetailApproval />
                    //return <Step2DetailIneligible/>
                } else {
                    return <Step2DetailRejection />
                }
            }
            if (project.secondStepDecision.eligibilityDecision !== null) {
                if (project.secondStepDecision.eligibilityDecision.status === 'ELIGIBLE') {
                    return 'Eligible'
                } else {
                    return <Step2DetailIneligible/>
                }
            } else {
                return this.displayError(null, 'There is no Step2 Decision at the moment', 'It\'s not possible to print a notification letter without any decision, please check in Jems application if the Step2 decision is available');
            }
        } else {
            return this.displayError(null, 'There is no Step2 Decision at the moment', 'It\'s not possible to print a notification letter without any decision, please check in Jems application if the Step2 decision is available');
        }
    }

    displayError = (error, title, message) => {
        return (<Message negative><Message.Header>{title}</Message.Header>{message}</Message>);
    }

    render() {
        return (
            <div>
                {this.getEligibilityDecision()}
            </div>
        )
    }

}

export default Step2NotificationLetter
